import { render, staticRenderFns } from "./AppItemList.vue?vue&type=template&id=5b4d207d"
import script from "./AppItemList.vue?vue&type=script&lang=js"
export * from "./AppItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports